export default "__VITE_ASSET__TmWE9Dbp__"